export const SET_DECLINE_REASON = "SET_DECLINE_REASON";

export const setDeclineReason = (declineReason) => {
    return {
        type: SET_DECLINE_REASON,
        declineReason
    }
};
